export default __webpack_public_path__ + "static/media/x-ray-viewint-room.8850fbbc.jpeg";